import { render, staticRenderFns } from "./WisdomDataPoleStar.vue?vue&type=template&id=3335abf7&"
import script from "./WisdomDataPoleStar.vue?vue&type=script&lang=js&"
export * from "./WisdomDataPoleStar.vue?vue&type=script&lang=js&"
import style0 from "./WisdomDataPoleStar.vue?vue&type=style&index=0&id=3335abf7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports